import React from 'react';

const IconProviderContext = /*#__PURE__*/React.createContext({});
const IconProvider = IconProviderContext.Provider;
const useIconProviderContext = () => {
  return React.useContext(IconProviderContext);
};

export { IconProvider, IconProviderContext, useIconProviderContext };
